import { useMatchRoute } from '@tanstack/react-router';
import { useCallback } from 'react';

interface UseSamePageNavigationReturn {
  isCurrentPage: (to: string, params: Record<string, string>) => boolean;
}

export const useSamePageNavigation = (): UseSamePageNavigationReturn => {
  const matchRoute = useMatchRoute();

  const isCurrentPage = useCallback(
    (to: string, params: Record<string, string>) => {
      const match = matchRoute({ to, params }) as Record<string, string> | false;

      if (!match) return false;

      return JSON.stringify(params) === JSON.stringify(match);
    },
    [matchRoute],
  );

  return { isCurrentPage };
};
